import { ParamsError } from "../../../../utils/fetchCustomPdp";

export const TelefoniaMovilParamsError: ParamsError = {
  errorCustomFetch: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
  errorCustomFetchTimeout: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
  errorCustomFetchCode: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
  errorCustomApiGateway: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
  errorCustomApiGatewayTimeout: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
  errorCustomBackend: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
  errorCustomBackendUser: {
    typeNotify: "notify",
    ignoring: false,
    console_error: true,
  },
  errorCustomBackendPending: {
    typeNotify: "notifyError",
    ignoring: false,
    console_error: true,
  },
};

export const TelefoniaMovilCyclePeticionParamsError: ParamsError = {
  ...TelefoniaMovilParamsError,
  errorCustomApiGatewayTimeout: {
    typeNotify: "notifyError",
    ignoring: true,
  },
  errorCustomBackend: {
    typeNotify: "notifyError",
    ignoring: true,
  },
};

export const TelefoniaMovilConsultaTimeoutParamsError: ParamsError = {
  ...TelefoniaMovilParamsError,
  errorCustomBackend: {
    typeNotify: "notifyError",
    ignoring: true,
  },
};
